import type { Language } from '@/types';

export const labels: Record<Language, Record<string, string>> = {
  ar: {
    appTitle: 'وِقاية — نظام العيادة',
    signIn: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signOut: 'تسجيل الخروج',
    dashboard: 'لوحة التحكم',
    patients: 'المرضى',
    schedule: 'المواعيد',
    assessments: 'التقييمات',
    plans: 'خطط العلاج',
    sessions: 'الجلسات',
    nutrition: 'التغذية العلاجية',
    services: 'الخدمات',
    packages: 'الباقات',
    inventory: 'المخزن',
    billing: 'الفواتير',
    finance: 'المالية',
    reports: 'التقارير',
    files: 'الملفات',
    employees: 'الموظفون',
    settings: 'الإعدادات',
    more: 'المزيد',
    welcome: 'مرحباً',
    loading: 'جاري التحميل…',
    save: 'حفظ',
    refresh: 'تحديث',
    language: 'اللغة',
    placeholderModule: 'هذا القسم جاهز للربط مع قاعدة البيانات. استخدم القائمة للتنقل.',
    newPatient: 'مريض جديد',
    patientName: 'اسم المريض',
    phone: 'الهاتف',
    activePatients: 'مرضى نشطون',
    todayAppointments: 'مواعيد اليوم',
    noRows: 'لا توجد بيانات.',
    patientCode: 'الكود',
    open: 'فتح',
    searchPatients: 'بحث',
    searchPlaceholder: 'اسم، كود، هاتف…',
    back: 'رجوع',
    demographics: 'البيانات الشخصية',
    medicalInfo: 'معلومات طبية',
    nationalId: 'الرقم القومي',
    birthDate: 'تاريخ الميلاد',
    gender: 'النوع',
    governorate: 'المحافظة',
    address: 'العنوان',
    jobTitle: 'المهنة',
    primaryPhysician: 'الطبيب المعالج',
    emergencyContact: 'طوارئ — اسم',
    emergencyRelation: 'صلة القرابة',
    medicalHistory: 'التاريخ المرضي',
    allergyNotes: 'الحساسية',
    saveChanges: 'حفظ التعديلات',
    appointmentsUpcoming: 'مواعيد قادمة',
    appointmentsTotal: 'إجمالي المواعيد',
    recentAppointments: 'آخر المواعيد',
    goToSchedule: 'جدولة موعد',
    pendingToday: 'مواعيد اليوم (غير مكتملة)',
    sessionsThisWeek: 'جلسات آخر 7 أيام',
    revenueMonth: 'تحصيل الشهر (ج.م.)',
    quickLinks: 'اختصارات',
    whatsapp: 'واتساب',
    lowStock: 'تنبيه المخزون',
    lowStockItems: 'صنف منخفض',
    newItem: 'صنف جديد',
    nameEn: 'الاسم (إنجليزي)',
    nameAr: 'الاسم (عربي)',
    category: 'التصنيف',
    quantity: 'الكمية',
    minStock: 'الحد الأدنى',
    unit: 'الوحدة',
    cost: 'التكلفة',
    selling: 'سعر البيع',
    supplier: 'المورد',
    stockMovement: 'حركة مخزون',
    item: 'الصنف',
    movementType: 'نوع الحركة',
    reason: 'السبب',
    reference: 'المرجع',
    movementLog: 'سجل الحركات',
    date: 'التاريخ',
    newService: 'خدمة جديدة',
    durationMin: 'المدة (دقيقة)',
    price: 'السعر',
    notes: 'ملاحظات',
    active: 'نشط',
    newAssessment: 'تقييم جديد',
    diagnosis: 'التشخيص',
    painScore: 'الألم (0–10)',
    chiefComplaint: 'الشكوى الرئيسية',
    redFlags: 'علامات خطر',
    functionalLimitations: 'القيود الوظيفية',
    recommendations: 'التوصيات',
    bodyComposition: 'تكوين الجسم',
    measuredAt: 'تاريخ القياس',
    heightCm: 'الطول (سم)',
    weightKg: 'الوزن (كجم)',
    waistCm: 'الخصر (سم)',
    bodyFat: 'دهون الجسم %',
    bmi: 'مؤشر كتلة الجسم',
    bmiShort: 'BMI',
    bmiPreview: 'معاينة مؤشر كتلة الجسم',
    bmiEnterHeightWeight: 'أدخل الطول والوزن لحساب BMI تلقائياً.',
    bmiCategoryUnder: 'نقص وزن',
    bmiCategoryNormal: 'طبيعي',
    bmiCategoryOver: 'زيادة وزن',
    bmiCategoryObese: 'سمنة',
    bloodPressure: 'ضغط الدم',
    bpSystolic: 'انقباضي',
    bpDiastolic: 'انبساطي',
    glucose: 'السكر الصائم (مغ/دل)',
    nutritionHistory: 'سجل تكوين الجسم',
    plansHistory: 'خطط التغذية',
    macros: 'المغذيات الكبرى',
    proteinG: 'بروتين (غ)',
    carbsG: 'كربوهيدرات (غ)',
    fatG: 'دهون (غ)',
    nutritionPlanSubtitle: 'تسجيل خطة علاجية مع الأهداف الغذائية.',
    bodyCompSubtitle: 'قياسات دورية مع حساب BMI عند توفر الطول والوزن.',
    nutritionSectionRecord: 'قياس جديد',
    nutritionSectionPlans: 'خطة جديدة',
    nutritionPlan: 'خطة غذائية',
    planDate: 'تاريخ الخطة',
    status: 'الحالة',
    calories: 'السعرات',
    followUp: 'متابعة',
    newInvoice: 'فاتورة جديدة',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    tax: 'الضريبة',
    paid: 'المدفوع',
    total: 'الإجمالي',
    invoice: 'الفاتورة',
    amount: 'المبلغ',
    method: 'طريقة الدفع',
    recordPayment: 'تسجيل دفعة',
    revenue: 'الإيرادات',
    expensesTotal: 'إجمالي المصروفات',
    netIncome: 'صافي',
    newExpense: 'مصروف جديد',
    expenses: 'المصروفات',
    dateRange: 'الفترة',
    from: 'من',
    to: 'إلى',
    exportCsv: 'تصدير CSV',
    completedSessions: 'جلسات في الفترة',
    newPatients: 'مرضى جدد في الفترة',
    appointmentsDone: 'مواعيد مكتملة',
    uploadFile: 'رفع ملف',
    title: 'العنوان',
    newPlan: 'خطة علاج جديدة',
    planName: 'اسم الخطة',
    startDate: 'البداية',
    endDate: 'النهاية',
    goalsSummary: 'الأهداف',
    interventions: 'التدخلات',
    newSession: 'جلسة جديدة',
    sessionDate: 'تاريخ الجلسة',
    painBefore: 'ألم قبل',
    painAfter: 'ألم بعد',
    billed: 'مفوترة',
    viewDay: 'يوم',
    viewWeek: 'أسبوع',
    viewMonth: 'شهر',
    newAppointment: 'موعد جديد',
    therapist: 'المعالج',
    visitType: 'نوع الزيارة',
    start: 'البداية',
    end: 'النهاية',
    todayList: 'مواعيد اليوم',
    newPackage: 'باقة جديدة',
    packageName: 'اسم الباقة',
    totalSessions: 'عدد الجلسات',
    usedSessions: 'المستخدم',
    remaining: 'المتبقي',
    fullName: 'الاسم الكامل',
    role: 'الدور',
    roleOwner: 'مالك',
    roleManager: 'مدير',
    roleReceptionist: 'استقبال',
    roleTherapist: 'معالج فيزيائي',
    roleDoctor: 'طبيب',
    roleNutritionist: 'أخصائي تغذية',
    roleCashier: 'محاسب / كاشير',
    roleStorekeeper: 'أمين مخزن',
    roleBilling: 'فواتير',
    roleAssistant: 'مساعد',
    addUser: 'إضافة مستخدم',
    addUserModePassword: 'كلمة مرور الآن',
    addUserModeInvite: 'دعوة بالبريد',
    confirmPassword: 'تأكيد كلمة المرور',
    generatePassword: 'توليد',
    showPassword: 'إظهار',
    hidePassword: 'إخفاء',
    createAccount: 'إنشاء الحساب',
    creatingAccount: 'جاري الإنشاء…',
    createAccountHelp: 'يُنشأ المستخدم في Supabase Auth ثم يُحدَّد ملفه في جدول الموظفين.',
    inviteHelp: 'يُرسل بريد دعوة من Supabase (يتطلب ضبط SMTP في المشروع). المستخدم يضبط كلمة المرور من الرابط.',
    employeesNoPermission: 'إضافة وتعديل الموظفين متاحة للمالك أو المدير فقط.',
    userCreatedSuccess: 'تم إنشاء الحساب.',
    inviteSentSuccess: 'تم إرسال الدعوة.',
    copyEmail: 'نسخ البريد',
    copyPassword: 'نسخ كلمة المرور',
    dismiss: 'إغلاق',
    passwordMismatch: 'كلمتا المرور غير متطابقتين.',
    passwordTooShort: 'كلمة المرور يجب أن تكون ٦ أحرف على الأقل.',
    passwordHint: 'شارك كلمة المرور المؤقتة مع الموظف بشكل آمن (لا تُرسل بالبريد غير المشفّر إن أمكن).',
    inviteEmailNote: 'تحقق من صندوق الوارد (والبريد المزعج).',
    weakPassword: 'يُفضّل ٨ أحرف على الأقل مع أرقام وحروف.',
    specialty: 'التخصص',
    tempPassword: 'كلمة مرور مؤقتة',
    requestFailed: 'تعذّر إكمال الطلب.',
    emailOrUsername: 'البريد أو اسم المستخدم',
    emailOrUsernamePlaceholder: 'ahmed@clinic.com أو ahmed.pt',
    emailOrUsernameHelp:
      'بدون @ يُعامل كاسم مستخدم ويُنشأ بريد دخول داخلي (يجب أن يطابق نطاق الخادم والواجهة).',
    copySignInEmail: 'نسخ بريد الدخول',
    signInUsesSyntheticEmail: 'بريد الدخول في النظام',
    inviteRequiresRealEmail: 'يتطلب بريداً حقيقياً',
    usernameNoInvite: 'دعوة البريد غير متاحة لأسماء المستخدمين — استخدم «كلمة مرور الآن».',
    username: 'اسم المستخدم',
    loginHint: 'يمكنك إدخال البريد الكامل أو اسم المستخدم فقط.',
    /* === New: nav sections === */
    navSectionMain: 'الأساسية',
    navSectionClinical: 'العيادة',
    navSectionOperations: 'العمليات',
    navSectionFinance: 'المالية',
    navSectionAdmin: 'الإدارة',
    navigation: 'القائمة',
    openMenu: 'فتح القائمة',
    collapseSidebar: 'تصغير الشريط الجانبي',
    expandSidebar: 'توسيع الشريط الجانبي',
    /* === Theme === */
    theme: 'المظهر',
    themeLight: 'فاتح',
    themeDark: 'داكن',
    themeAuto: 'تلقائي',
    /* === Greetings === */
    greetingMorning: 'صباح الخير',
    greetingAfternoon: 'مساء النور',
    greetingEvening: 'مساء الخير',
    greetingNight: 'طاب مساؤك',
    /* === Generic UI === */
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    close: 'إغلاق',
    apply: 'تطبيق',
    search: 'بحث',
    filter: 'تصفية',
    all: 'الكل',
    today: 'اليوم',
    yesterday: 'الأمس',
    tomorrow: 'غداً',
    upcoming: 'قادم',
    next: 'التالي',
    previous: 'السابق',
    none: 'لا شيء',
    yes: 'نعم',
    no: 'لا',
    optional: 'اختياري',
    required: 'مطلوب',
    actions: 'إجراءات',
    overview: 'نظرة عامة',
    timeline: 'الجدول الزمني',
    visits: 'الزيارات',
    documents: 'المستندات',
    vitals: 'العلامات الحيوية',
    profile: 'الملف',
    history: 'السجل',
    summary: 'الملخص',
    quickAdd: 'إضافة سريعة',
    noResults: 'لا توجد نتائج للبحث.',
    tryAgain: 'إعادة المحاولة',
    saveSuccess: 'تم الحفظ بنجاح',
    updateSuccess: 'تم التحديث بنجاح',
    deleteSuccess: 'تم الحذف بنجاح',
    deleteConfirm: 'هل أنت متأكد من الحذف؟',
    /* === Status === */
    statusScheduled: 'مجدول',
    statusConfirmed: 'مؤكد',
    statusCheckedIn: 'حاضر',
    statusDone: 'مكتمل',
    statusCancelled: 'ملغي',
    statusNoShow: 'لم يحضر',
    invoiceStatusDraft: 'مسودة',
    invoiceStatusIssued: 'مُصدرة',
    invoiceStatusPaid: 'مدفوعة',
    invoiceStatusVoid: 'لاغية',
    planStatusDraft: 'مسودة',
    planStatusActive: 'نشطة',
    planStatusCompleted: 'مكتملة',
    /* === Dashboard === */
    welcomeBack: 'أهلاً بعودتك',
    weeklyOverview: 'نظرة أسبوعية',
    upcomingToday: 'مواعيد اليوم القادمة',
    recentPatients: 'مرضى جدد',
    quickStart: 'إجراءات سريعة',
    /* === Patients === */
    patientOverview: 'نظرة عامة',
    patientProfile: 'الملف الشخصي',
    patientVitals: 'العلامات الحيوية والقياسات',
    patientVisits: 'الزيارات والجلسات',
    patientDocuments: 'المستندات',
    addPatient: 'إضافة مريض',
    editPatient: 'تعديل بيانات المريض',
    patientNotFound: 'لم يتم العثور على هذا المريض.',
    contactInfo: 'بيانات التواصل',
    /* === Schedule === */
    bookNow: 'حجز موعد',
    weekView: 'عرض الأسبوع',
    dayView: 'عرض اليوم',
    monthView: 'عرض الشهر',
    therapistView: 'حسب المعالج',
    nothingScheduled: 'لا توجد مواعيد في هذا اليوم.',
    /* === Billing === */
    newPayment: 'تسجيل دفعة',
    outstanding: 'مستحق',
    paidOf: 'مدفوع من',
    /* === Files === */
    pickFile: 'اختر ملفاً',
    download: 'تنزيل',
    /* === Sessions === */
    soapSubjective: 'الذاتي (S)',
    soapObjective: 'الموضوعي (O)',
    soapAssessment: 'التقييم (A)',
    soapPlan: 'الخطة (P)',
    /* === Notifications === */
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات جديدة.',
    /* === PWA === */
    installApp: 'تثبيت التطبيق',
    installAppHint: 'ثبّت وِقاية على شاشتك الرئيسية لتجربة أسرع.',
    install: 'تثبيت',
    /* === WhatsApp === */
    sendWhatsApp: 'إرسال واتساب',
    whatsappMessage: 'الرسالة',
    whatsappTemplate: 'قالب الرسالة',
    whatsappSend: 'فتح واتساب',
    whatsappNoNumber: 'لا يوجد رقم واتساب لهذا المريض',
    whatsappTemplateAppointment: 'تذكير بالموعد',
    whatsappTemplateFollowUp: 'متابعة المريض',
    whatsappTemplateWelcome: 'ترحيب بمريض جديد',
    whatsappTemplateOffer: 'عرض خاص',
    whatsappTemplateCustom: 'رسالة مخصصة',
    /* === Misc === */
    sessionsCount: 'جلسة',
    sessionsLast30: 'الجلسات خلال 30 يومًا',
    revenueLast30: 'إيرادات 30 يومًا',
    appointmentsThisWeek: 'مواعيد هذا الأسبوع',
    patientsGrowth: 'تطور المرضى',
  },
  en: {
    appTitle: 'Wiqaya — Clinic OS',
    signIn: 'Sign in',
    email: 'Email',
    password: 'Password',
    signOut: 'Sign out',
    dashboard: 'Dashboard',
    patients: 'Patients',
    schedule: 'Schedule',
    assessments: 'Assessments',
    plans: 'Treatment plans',
    sessions: 'Sessions',
    nutrition: 'Nutrition',
    services: 'Services',
    packages: 'Packages',
    inventory: 'Inventory',
    billing: 'Billing',
    finance: 'Finance',
    reports: 'Reports',
    files: 'Files',
    employees: 'Employees',
    settings: 'Settings',
    more: 'More',
    welcome: 'Welcome',
    loading: 'Loading…',
    save: 'Save',
    refresh: 'Refresh',
    language: 'Language',
    placeholderModule: 'This section is wired for navigation. Connect features to Supabase as needed.',
    newPatient: 'New patient',
    patientName: 'Patient name',
    phone: 'Phone',
    activePatients: 'Active patients',
    todayAppointments: 'Appointments today',
    noRows: 'No data yet.',
    patientCode: 'Code',
    open: 'Open',
    searchPatients: 'Search',
    searchPlaceholder: 'Name, code, phone…',
    back: 'Back',
    demographics: 'Demographics',
    medicalInfo: 'Medical',
    nationalId: 'National ID',
    birthDate: 'Birth date',
    gender: 'Gender',
    governorate: 'Governorate',
    address: 'Address',
    jobTitle: 'Job title',
    primaryPhysician: 'Primary physician',
    emergencyContact: 'Emergency contact',
    emergencyRelation: 'Relation',
    medicalHistory: 'Medical history',
    allergyNotes: 'Allergies',
    saveChanges: 'Save changes',
    appointmentsUpcoming: 'Upcoming appointments',
    appointmentsTotal: 'Total appointments',
    recentAppointments: 'Recent appointments',
    goToSchedule: 'Book appointment',
    pendingToday: 'Today (pending)',
    sessionsThisWeek: 'Sessions (7 days)',
    revenueMonth: 'Collected this month',
    quickLinks: 'Quick links',
    whatsapp: 'WhatsApp',
    lowStock: 'Low stock',
    lowStockItems: 'items below minimum',
    newItem: 'New item',
    nameEn: 'Name (EN)',
    nameAr: 'Name (AR)',
    category: 'Category',
    quantity: 'Quantity',
    minStock: 'Min stock',
    unit: 'Unit',
    cost: 'Cost',
    selling: 'Selling price',
    supplier: 'Supplier',
    stockMovement: 'Stock movement',
    item: 'Item',
    movementType: 'Movement type',
    reason: 'Reason',
    reference: 'Reference',
    movementLog: 'Movement log',
    date: 'Date',
    newService: 'New service',
    durationMin: 'Duration (min)',
    price: 'Price',
    notes: 'Notes',
    active: 'Active',
    newAssessment: 'New assessment',
    diagnosis: 'Diagnosis',
    painScore: 'Pain (0–10)',
    chiefComplaint: 'Chief complaint',
    redFlags: 'Red flags',
    functionalLimitations: 'Functional limits',
    recommendations: 'Recommendations',
    bodyComposition: 'Body composition',
    measuredAt: 'Measured at',
    heightCm: 'Height (cm)',
    weightKg: 'Weight (kg)',
    waistCm: 'Waist (cm)',
    bodyFat: 'Body fat %',
    bmi: 'Body mass index',
    bmiShort: 'BMI',
    bmiPreview: 'BMI preview',
    bmiEnterHeightWeight: 'Enter height and weight to calculate BMI.',
    bmiCategoryUnder: 'Underweight',
    bmiCategoryNormal: 'Normal',
    bmiCategoryOver: 'Overweight',
    bmiCategoryObese: 'Obesity',
    bloodPressure: 'Blood pressure',
    bpSystolic: 'Systolic',
    bpDiastolic: 'Diastolic',
    glucose: 'Fasting glucose (mg/dL)',
    nutritionHistory: 'Body composition history',
    plansHistory: 'Nutrition plans',
    macros: 'Macronutrients',
    proteinG: 'Protein (g)',
    carbsG: 'Carbs (g)',
    fatG: 'Fat (g)',
    nutritionPlanSubtitle: 'Therapeutic plan with macro targets.',
    bodyCompSubtitle: 'Periodic measures; BMI is derived from height and weight when available.',
    nutritionSectionRecord: 'New measurement',
    nutritionSectionPlans: 'New plan',
    nutritionPlan: 'Nutrition plan',
    planDate: 'Plan date',
    status: 'Status',
    calories: 'Calories',
    followUp: 'Follow-up',
    newInvoice: 'New invoice',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    paid: 'Paid',
    total: 'Total',
    invoice: 'Invoice',
    amount: 'Amount',
    method: 'Method',
    recordPayment: 'Record payment',
    revenue: 'Revenue',
    expensesTotal: 'Total expenses',
    netIncome: 'Net',
    newExpense: 'New expense',
    expenses: 'Expenses',
    dateRange: 'Date range',
    from: 'From',
    to: 'To',
    exportCsv: 'Export CSV',
    completedSessions: 'Sessions in range',
    newPatients: 'New patients in range',
    appointmentsDone: 'Completed appointments',
    uploadFile: 'Upload file',
    title: 'Title',
    newPlan: 'New treatment plan',
    planName: 'Plan name',
    startDate: 'Start',
    endDate: 'End',
    goalsSummary: 'Goals',
    interventions: 'Interventions',
    newSession: 'New session',
    sessionDate: 'Session date/time',
    painBefore: 'Pain before',
    painAfter: 'Pain after',
    billed: 'Billed',
    viewDay: 'Day',
    viewWeek: 'Week',
    viewMonth: 'Month',
    newAppointment: 'New appointment',
    therapist: 'Therapist',
    visitType: 'Visit type',
    start: 'Start',
    end: 'End',
    todayList: 'Today',
    newPackage: 'New package',
    packageName: 'Package name',
    totalSessions: 'Total sessions',
    usedSessions: 'Used',
    remaining: 'Remaining',
    fullName: 'Full name',
    role: 'Role',
    roleOwner: 'Owner',
    roleManager: 'Manager',
    roleReceptionist: 'Receptionist',
    roleTherapist: 'Therapist',
    roleDoctor: 'Doctor',
    roleNutritionist: 'Nutritionist',
    roleCashier: 'Cashier',
    roleStorekeeper: 'Storekeeper',
    roleBilling: 'Billing',
    roleAssistant: 'Assistant',
    addUser: 'Add user',
    addUserModePassword: 'Set password now',
    addUserModeInvite: 'Email invite',
    confirmPassword: 'Confirm password',
    generatePassword: 'Generate',
    showPassword: 'Show',
    hidePassword: 'Hide',
    createAccount: 'Create account',
    creatingAccount: 'Creating…',
    createAccountHelp: 'Creates the user in Supabase Auth and syncs the staff profile.',
    inviteHelp: 'Sends Supabase’s invite email (configure SMTP in the Supabase project). The user sets their password from the link.',
    employeesNoPermission: 'Only an owner or manager can add and manage employees.',
    userCreatedSuccess: 'Account created.',
    inviteSentSuccess: 'Invitation sent.',
    copyEmail: 'Copy email',
    copyPassword: 'Copy password',
    dismiss: 'Dismiss',
    passwordMismatch: 'Passwords do not match.',
    passwordTooShort: 'Password must be at least 6 characters.',
    passwordHint: 'Share the temporary password with the staff member securely.',
    inviteEmailNote: 'Ask them to check inbox and spam.',
    weakPassword: 'Prefer 8+ characters with letters and numbers.',
    specialty: 'Specialty',
    tempPassword: 'Temporary password',
    requestFailed: 'Request could not be completed.',
    emailOrUsername: 'Email or username',
    emailOrUsernamePlaceholder: 'ahmed@clinic.com or ahmed.pt',
    emailOrUsernameHelp:
      'If there is no @, the value is treated as a username and mapped to an internal sign-in email (VITE_STAFF_LOGIN_EMAIL_DOMAIN must match the Edge secret STAFF_INTERNAL_EMAIL_DOMAIN).',
    copySignInEmail: 'Copy sign-in email',
    signInUsesSyntheticEmail: 'Sign-in email in the system',
    inviteRequiresRealEmail: 'Requires a real email address',
    usernameNoInvite: 'Email invite is not available for usernames — use “Set password now”.',
    username: 'Username',
    loginHint: 'Use your full email or your username only.',
    /* === New: nav sections === */
    navSectionMain: 'Main',
    navSectionClinical: 'Clinical',
    navSectionOperations: 'Operations',
    navSectionFinance: 'Finance',
    navSectionAdmin: 'Administration',
    navigation: 'Navigation',
    openMenu: 'Open menu',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    /* === Theme === */
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeAuto: 'System',
    /* === Greetings === */
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    greetingNight: 'Good night',
    /* === Generic UI === */
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    apply: 'Apply',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    upcoming: 'Upcoming',
    next: 'Next',
    previous: 'Previous',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    optional: 'Optional',
    required: 'Required',
    actions: 'Actions',
    overview: 'Overview',
    timeline: 'Timeline',
    visits: 'Visits',
    documents: 'Documents',
    vitals: 'Vitals',
    profile: 'Profile',
    history: 'History',
    summary: 'Summary',
    quickAdd: 'Quick add',
    noResults: 'No results match your search.',
    tryAgain: 'Try again',
    saveSuccess: 'Saved successfully',
    updateSuccess: 'Updated successfully',
    deleteSuccess: 'Deleted successfully',
    deleteConfirm: 'Are you sure you want to delete?',
    /* === Status === */
    statusScheduled: 'Scheduled',
    statusConfirmed: 'Confirmed',
    statusCheckedIn: 'Checked in',
    statusDone: 'Completed',
    statusCancelled: 'Cancelled',
    statusNoShow: 'No show',
    invoiceStatusDraft: 'Draft',
    invoiceStatusIssued: 'Issued',
    invoiceStatusPaid: 'Paid',
    invoiceStatusVoid: 'Void',
    planStatusDraft: 'Draft',
    planStatusActive: 'Active',
    planStatusCompleted: 'Completed',
    /* === Dashboard === */
    welcomeBack: 'Welcome back',
    weeklyOverview: 'Weekly overview',
    upcomingToday: 'Upcoming today',
    recentPatients: 'New patients',
    quickStart: 'Quick actions',
    /* === Patients === */
    patientOverview: 'Overview',
    patientProfile: 'Profile',
    patientVitals: 'Vitals & body composition',
    patientVisits: 'Visits & sessions',
    patientDocuments: 'Documents',
    addPatient: 'Add patient',
    editPatient: 'Edit patient',
    patientNotFound: 'Patient not found.',
    contactInfo: 'Contact info',
    /* === Schedule === */
    bookNow: 'Book appointment',
    weekView: 'Week',
    dayView: 'Day',
    monthView: 'Month',
    therapistView: 'By therapist',
    nothingScheduled: 'No appointments for this day.',
    /* === Billing === */
    newPayment: 'Record payment',
    outstanding: 'Outstanding',
    paidOf: 'paid of',
    /* === Files === */
    pickFile: 'Choose a file',
    download: 'Download',
    /* === Sessions === */
    soapSubjective: 'Subjective (S)',
    soapObjective: 'Objective (O)',
    soapAssessment: 'Assessment (A)',
    soapPlan: 'Plan (P)',
    /* === Notifications === */
    notifications: 'Notifications',
    noNotifications: 'No new notifications.',
    /* === PWA === */
    installApp: 'Install app',
    installAppHint: 'Install Wiqaya on your device for a faster experience.',
    install: 'Install',
    /* === WhatsApp === */
    sendWhatsApp: 'Send WhatsApp',
    whatsappMessage: 'Message',
    whatsappTemplate: 'Message template',
    whatsappSend: 'Open WhatsApp',
    whatsappNoNumber: 'No WhatsApp number for this patient',
    whatsappTemplateAppointment: 'Appointment reminder',
    whatsappTemplateFollowUp: 'Patient follow-up',
    whatsappTemplateWelcome: 'Welcome new patient',
    whatsappTemplateOffer: 'Special offer',
    whatsappTemplateCustom: 'Custom message',
    /* === Misc === */
    sessionsCount: 'sessions',
    sessionsLast30: 'Sessions (30 days)',
    revenueLast30: 'Revenue (30 days)',
    appointmentsThisWeek: 'Appointments this week',
    patientsGrowth: 'Patient growth',
  },
};

export function t(lang: Language, key: string): string {
  return labels[lang][key] ?? labels.en[key] ?? key;
}
